import { useTranslation } from "react-i18next";
import { CountUp } from "../../Utils";
import { TruckIcon } from "@heroicons/react/24/outline";

const formatKm = (value) => {
  const num = Number(value) || 0;
  return num.toLocaleString(undefined, { maximumFractionDigits: 1 });
};

const StatCard = ({ label, value, accentClass = "text-indigo-600" }) => (
  <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-200">
    <div className="text-sm text-gray-500">{label}</div>
    <div className={`text-xl font-bold ${accentClass}`}>
      <CountUp value={value || 0} /> km
    </div>
  </div>
);

export const TripsStatsSection = ({ item }) => {
  const { t } = useTranslation();

  if (!item?.id) {
    return null;
  }

  const stats = [
    {
      label: t("vehicle.trips_stats.total_distance"),
      value: item.distance_driven,
      accentClass: "text-indigo-600",
    },
    {
      label: t("vehicle.trips_stats.this_month"),
      value: item.distance_driven_this_month,
      accentClass: "text-purple-600",
    },
    {
      label: t("vehicle.trips_stats.this_year"),
      value: item.distance_driven_this_year,
      accentClass: "text-blue-600",
    },
    {
      label: t("vehicle.trips_stats.last_year"),
      value: item.distance_driven_last_year,
      accentClass: "text-gray-700",
    },
    {
      label: t("vehicle.trips_stats.estimated_this_year"),
      value: item.distance_driven_estimated_this_year,
      accentClass: "text-amber-600",
    },
  ];

  return (
    <div className="mt-5 shadow sm:overflow-hidden sm:rounded-md">
      <div className="space-y-6 bg-white py-6 px-4 sm:p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <TruckIcon className="h-6 w-6 text-indigo-600" aria-hidden="true" />
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                {t("vehicle.trips_stats.title")}
              </h3>
            </div>
            <p className="mt-1 text-sm text-gray-500">
              {t("vehicle.trips_stats.subtitle")}
            </p>
          </div>
          <div className="text-right">
            <div className="text-sm text-gray-500">{t("vehicle.trips_stats.trip_count")}</div>
            <div className="text-2xl font-bold text-gray-900">
              {(item.trips_count || 0).toLocaleString()}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {stats.map((stat) => (
            <StatCard key={stat.label} {...stat} />
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2 border-t border-gray-100">
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-1">
              {t("vehicle.trips_stats.today")}
            </span>
            <p className="text-sm text-gray-900">{formatKm(item.distance_driven_today)} km</p>
          </div>
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-1">
              {t("vehicle.trips_stats.this_week")}
            </span>
            <p className="text-sm text-gray-900">{formatKm(item.distance_driven_this_week)} km</p>
          </div>
          <div>
            <span className="block text-sm font-medium text-gray-700 mb-1">
              {t("Current Odometer (km)")}
            </span>
            <p className="text-sm text-gray-900">
              {item.current_odometer_in_kilometers
                ? `${Number(item.current_odometer_in_kilometers).toLocaleString()} km`
                : "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
